import {
  ORGANIZATIONAL_COMMITMENT_GET_URL,
  ORGANIZATIONAL_COMMITMENT_POST_URL
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getOrganizationCommitment =
  associationsNum => (dispatch, getState) =>
    asyncRequest({
      url: ORGANIZATIONAL_COMMITMENT_GET_URL(associationsNum),
      successAction: data => ({
        type: types.GET_ORGANIZATIONAL_COMMITMENT_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.GET_ORGANIZATIONAL_COMMITMENT_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOrganizationCommitment = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: ORGANIZATIONAL_COMMITMENT_POST_URL(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.POST_ORGANIZATIONAL_COMMITMENT_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_ORGANIZATIONAL_COMMITMENT_FAILURE,
      payload: error
    }),
    dispatch
  });
export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
